//ArtiklarSection
import React from 'react';
import {Grid} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty} from 'lodash'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import SelectDetails from '../Inputs/SelectDetails'
import CheckBoxInputTaggningAr from '../Inputs/CheckBoxInputTaggningAr'
//import ItemsTypeInput from '../Inputs/ItemsTypeInput'

function ArtiklarSection(props) {
    const CurrentObjekt = useSelector(state => state.accountsData.CurrentObjekt)
    const Flags = useSelector(state => state.accountsData.Flags) 
    let user = useSelector(state => state.auth.authUser)
    const onChangeMstate=(Chips)=>{
        console.log(Chips)
    }
    let TB1Lable = Flags.KalkylPlus === 1?user.user_canSeeTB1 === 1?"TB2":"TB":"TB"
    let TB2Lable = "TB"
    return (<>
    <Grid container direction="row" alignItems="center" className='mt-2 pt-2 pl-2' style={{maxHeight:460,minHeight:120,overflowY:"auto"}}>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
         <SelectDetails
         Meta="Typ" MetaN={"Artikel_Detailer"} 
         disabled={false} 
         Value={true} 
         onChangeMstate={props.onChangeMstate} 
         Mstate={props.Chips}
         />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Artikelnr" MetaN={"Artikel_Nr"} 
            disabled={props.Chips.some(item=>item.MetaN === "Artikel_Detailer" && parseInt(item.Value) === 1)} 
            Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Benämning" MetaN={"Artikel_Namn"} 
            disabled={props.Chips.some(item=>item.MetaN === "Artikel_Detailer" && parseInt(item.Value) === 1)} 
            Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Visningsnamn" MetaN={"Artikel_Visningsnamn"} 
            disabled={props.Chips.some(item=>item.MetaN === "Artikel_Detailer" && parseInt(item.Value) === 1)} 
            Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Leverantör" MetaN={"Artikel_Leverantor"} 
            disabled={props.Chips.some(item=>item.MetaN === "Artikel_Detailer" && parseInt(item.Value) === 1)} 
            Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="E-Nummer" MetaN={"Artikel_ENummer"} 
            disabled={props.Chips.some(item=>item.MetaN === "Artikel_Detailer" && parseInt(item.Value) === 1)} 
            Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Typ" MetaN={"Artikel_Typ"} 
            disabled={props.Chips.some(item=>item.MetaN === "Artikel_Detailer" && parseInt(item.Value) === 1)} 
            Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
       
        
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Beskrivning" MetaN={"Artikel_Beskrivning"} 
            disabled={props.Chips.some(item=>item.MetaN === "Artikel_Detailer" && parseInt(item.Value) === 1)} 
            Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Artikel utpris" MetaN={"Artikel_Utpris"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Artikel inpris" MetaN={"Artikel_Inpris"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>


        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta={`Artikel ${TB1Lable}`} MetaN={"Artikel_TB"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        {
            parseInt(Flags.KalkylPlus) === 1?
            <>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta={`Artikel ${TB2Lable}`} MetaN={"Artikel_TB2"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Artikel TB2 avdrag" MetaN={"Artikel_TB2_avdrag"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Artikel TB avdrag" MetaN={"Artikel_TB_avdrag"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        </>
        :""}

        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Artikel Antal" MetaN={"Artikel_Antal"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        {
            isEmpty(props.Chips)?"":
            props.Chips.some(item=>item.MetaN.includes("Prospekt_") || item.MetaN.includes("Avtal_"))?
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
                <CheckBoxInput Meta="Använt" MetaN={"Artikel_Antal_Använt"} disabled={false} Value={true} 
                onChangeMstate={props.onChangeMstate} 
                Mstate={props.Chips}
                />
            </Grid>
            :""
        }
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Artikel Rabatt" MetaN={"Artikel_Rabat"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta="Artikel Utpris Summa" MetaN={"Artikel_Summa"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInputTaggningAr Meta="Taggar" MetaN={"Artikel_Taggar"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
        </Grid>
        {
            isEmpty(props.Chips)?"":
            props.Chips.some(item=>item.MetaN.includes("Order_") )?
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
                <CheckBoxInput Meta="Artikel Fria fält" MetaN={"Artikel_Free_Inputs"} disabled={false} Value={true} 
                    onChangeMstate={props.onChangeMstate} 
                    Mstate={props.Chips}
                />
            </Grid>
            :""
        }
    </Grid>
    </>
    );
}

export default ArtiklarSection;